import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@deal/components'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { ShoppingCartOrderFragment } from '#src/generated/graphql'
import classNames from 'classnames'
import numeral from 'numeral'
import styles from './styles.css'

interface Props extends RouteComponentProps<any> {
  order: ShoppingCartOrderFragment
}

const Footer: React.SFC<Props> = ({ order }) => {
  const {
    id,
    totalCostWithoutTip,
    subtotal,
    totalShippingCost,
    itemsCount,
    tax,
    appliedPromotionEntry
  } = order
  return (
    <div className={styles.module}>
      <div className={styles.row}>
        <div className={styles.label}>Subtotal</div>
        <div className={styles.value}>{numeral(subtotal.amount).format('$0,0.00')}</div>
      </div>
      {totalShippingCost &&
        parseInt(totalShippingCost.amount, 10) > 0 && (
          <div className={styles.row}>
            <div className={styles.label}>Estimated shipping</div>
            <div className={styles.value}>
              {numeral(totalShippingCost.amount).format('$0,0.00')}
            </div>
          </div>
        )}
      <div className={styles.row}>
        <div className={styles.label}>Estimated tax</div>
        <div className={styles.value}>{numeral(tax.amount).format('$0,0.00')}</div>
      </div>
      {appliedPromotionEntry && (
        <div className={styles.row}>
          <div className={styles.label}>{appliedPromotionEntry.promotion.code}</div>
          <div className={styles.free}>
            -{numeral(appliedPromotionEntry.discount.amount).format('$0,0.00')}
          </div>
        </div>
      )}
      <div className={styles.row}>
        <div className={styles.label}>Total</div>
        <div className={classNames(styles.value, styles.total)}>
          {numeral(totalCostWithoutTip.amount).format('$0,0.00')}
        </div>
      </div>
      <div className={styles.buttons}>
        <Link to={`/orders/${id}/checkout`} className={styles.button}>
          <Button disabled={itemsCount === 0} className={styles.button}>
            Secure checkout
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default withRouter(Footer)
